import { selectClasses } from '@mui/material';

export const muiSelectOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				'&.Mui-readOnly': {
					backgroundColor: 'inherit',
					color: 'inherit',
				},
				[`.${selectClasses.nativeInput}`]: {
					border: 'none',
				},
				[`.${selectClasses.nativeInput}:placeholder-shown`]: {
					inset: `0 ${theme.tsGoUnit.tsUnitHalf}`,
					opacity: 1,

					'::placeholder': {
						color: '#98a2b3',
					},
				},
			};
		},
	},
};
